import React from "react";
import { useLocation } from "react-router-dom";

// Taken from https://v5.reactrouter.com/web/example/query-parameters
// A custom hook that builds on useLocation to parse
// the query string for you.
// Duplicate from customers part since it does not work when going through factor-lib
const useUrlQuery = (): URLSearchParams => {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
};

export default useUrlQuery;
